export const ASSIGN_ACCOUNT = 'ASSIGN_ACCOUNT';
export const ASSIGN_ACCOUNT_SUCCESS = 'ASSIGN_ACCOUNT_SUCCESS';
export const ASSIGN_ACCOUNT_FAILURE = 'ASSIGN_ACCOUNT_FAILURE';

export const FETCH_ASSIGNED_ACCOUNTS_LIST = 'FETCH_ASSIGNED_ACCOUNTS_LIST';
export const FETCH_ASSIGNED_ACCOUNTS_LIST_SUCCESS = 'FETCH_ASSIGNED_ACCOUNTS_LIST_SUCCESS';
export const FETCH_ASSIGNED_ACCOUNTS_LIST_FAILURE = 'FETCH_ASSIGNED_ACCOUNTS_LIST_FAILURE';
export const CLEAR_ASSIGNED_ACCOUNTS_LIST = 'CLEAR_ASSIGNED_ACCOUNTS_LIST';
